import React from 'react'
import gql from 'graphql-tag'
import moment from 'moment'
import {Link} from 'react-router-dom'
import {sumBy, formatPrice} from 'lib/util'
import Query from 'components/shared/Query'
import Heading from 'components/shared/Heading'
import Button from 'components/shared/Button'

const ordersQuery = gql`
  query OrdersQuery($estateId: ID!) {
    estate(id: $estateId) {
      id
      orders {
        edges {
          node {
            id
            createdAt
            total
            bundle {
              name
            }
            invoiceLines {
              id
              quantity
              description
              bundleId
            }
          }
        }
      }
    }
  }
`

const Order = ({match, order}) => {
  const nonBundleLines = order.invoiceLines.filter(line => !line.bundleId)

  return (
    <div className="order">
      <div className="order-header">
        <span className="date">
          {moment(order.createdAt).format('DD. MMMM YYYY')}
        </span>
        <span className="total">
          {formatPrice(order.total)}
        </span>
      </div>
      {!!order.bundle && (
        <div className="bundle">
          <span className="name">{order.bundle.name}</span>
        </div>
      )}
      <div className="lines">
        {nonBundleLines
          .map((line) => `${line.quantity > 1 ? line.quantity : ''} ${line.description}`.trim())
          .join(', ')
        }
      </div>
      <div className="actions">
        <Link to={`${match.url}/${order.id}`}>
          <Button type="navigation">Vis detaljer</Button>
        </Link>
      </div>
    </div>
  )
}

const List = ({match}) => {
  return (
    <div className="orders">
      <Heading level={2}>Ordreoversikt</Heading>

      <Query
        inlineLoading
        inlineError
        query={ordersQuery}
        variables={{
          estateId: match.params.estateId,
        }}
      >
        {({getData}) => {
          const orders = getData('estate.orders.edges').map(e => e.node)
          const total = sumBy(orders, o => o.total)

          return (
            <>
              <div className="orders-header">
                <span className="total">Totalpris</span>
                <span className="sum">{formatPrice(total)}</span>
              </div>

              <div className="list">
                {orders.map((order) => (
                  <Order
                    key={order.id}
                    match={match}
                    order={order}
                  />
                ))}
              </div>
            </>
          )
        }}
      </Query>
    </div>
  )
}

export default List
